module.exports = __webpack_public_path__ + "img/shape2_new.67facc21.png";